import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getEmitentes(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getEmitentesCadastro(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes/access/listarCadastro", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getEmitenteSimples(context, idEmitente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("emitentes/access/obterSimples/" + idEmitente).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getEmitente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes/access/obterCadastro", {ID_EMITENTE: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getEmitenteCadastroSimples(context, idEmitente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes/access/obterCadastroSimples", {ID_EMITENTE: idEmitente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteEmitente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes/access/excluir", {ID_EMITENTE: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postEmitente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes/access/salvarCadastro", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getEmitenteTelefones(context, idEmitente){
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("emitentes/access/buscarTelefones", {ID_EMITENTE: idEmitente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};